import { formatOneGraphData } from '../../navigationMenuParser';
import { locales } from '../../types';
import englishContent from './english';
import koreanContent from './korean';
import spanishContent from './spanish';
import turkishContent from './turkish';
export function getSignedInHeaderNavLinks(locale, navigationName) {
  navigationName = navigationName || 'DefaultSignedInHeader';
  var signedInHeaderNavLinks = {};

  switch (locale) {
    case locales.es:
    case locales['es-419']:
      signedInHeaderNavLinks = spanishContent[navigationName];
      break;

    case locales.ko:
      signedInHeaderNavLinks = koreanContent[navigationName];
      break;

    case locales.tr:
      signedInHeaderNavLinks = turkishContent[navigationName];
      break;

    default:
      signedInHeaderNavLinks = englishContent[navigationName];
  }

  return formatOneGraphData(signedInHeaderNavLinks);
}